export default __webpack_public_path__ + "static/media/geral.92e5e821.png";